import { hideFiltersCategoryAndCollection } from '@/redux/actions';
import { IS_MOBILE } from '@/utils/checkClientDeviceType';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FilterDrawer from '../../MiddleBody7/Components/FilterDrawer/FilterDrawer';
import useTriggerInitialFilterOptions from '@/hooks/useTriggerInitialFilterOptions';

export function FilterDrawerMidd6(props) {
  const dispatch = useDispatch();

  const { showFilterDrawer, handleShowFilterDrawer } = props;

  const { storeData, headerHeight, headerRef } = useSelector((state) => ({
    headerHeight: state.commonReducer.headerHeight,
    headerRef: state.commonReducer.headerRef,
    storeData: state.storeReducer.store,
  }));

  useTriggerInitialFilterOptions();

  useEffect(() => {
    dispatch(hideFiltersCategoryAndCollection(true));
    return () => {
      dispatch(hideFiltersCategoryAndCollection(false));
    };
  }, []);

  useEffect(() => {
    if (IS_MOBILE && showFilterDrawer) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }

    return () => {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
  }, [showFilterDrawer]);

  useEffect(() => {
    if (IS_MOBILE && headerRef.current) {
      showFilterDrawer
        ? (headerRef.current.style.display = 'none')
        : (headerRef.current.style.display = '');
    }
  }, [showFilterDrawer]);

  return (
    <AnimatePresence>
      {showFilterDrawer && (
        <motion.div
          key="filterDrawer"
          initial={{ opacity: 0, x: IS_MOBILE ? 0 : -300, zIndex: -1 }}
          transition={IS_MOBILE ? { duration: 0.5 } : { duration: 0.5 }}
          animate={{ opacity: 1, x: 0, zIndex: IS_MOBILE ? 12 : 0 }}
          exit={{ opacity: 0, x: IS_MOBILE ? 0 : -300, zIndex: -1 }}
          style={{
            display: 'flex',
            top: IS_MOBILE ? 0 : headerHeight,
            position: IS_MOBILE ? 'fixed' : 'sticky',
            background: 'white',
            height: 'fit-content',
          }}
        >
          <div
            className="filterDrawerWrapper"
            showFilterDrawer={showFilterDrawer}
            ref={props.filterDrawerWrapperRef}
            style={props.showFilterDrawer ? { display: 'unset' } : { display: 'none' }}
          >
            <FilterDrawer
              handleShowFilterDrawer={handleShowFilterDrawer}
              hideCollectionFilter={props.hideCollectionFilter}
              hideCategoryFilter={props.hideCategoryFilter}
              hideTags={props.hideTags}
            />
            {IS_MOBILE && props.showFilterDrawer && (
              <div
                onClick={handleShowFilterDrawer}
                className="filterDrawerMobileCtaContainer"
              >
                <div className="filterDrawerMobileCta">Close</div>
                <div
                  className="filterDrawerMobileCta"
                  style={{
                    background: `${storeData?.theme?.colors?.primary_color ?? '#222'}`,
                    color: '#fff',
                  }}
                >
                  Apply
                </div>
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
